"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.$unsubscribeFeedTyping = exports.$subscribeFeedTyping = exports.$postMulticastFeed = exports.$postAnchor = exports.$postAcknowledgement = exports.$patchMulticastFeed = exports.$patchFeed = exports.$getFeeds = exports.$getFeed = exports.$getAnchors = exports.$deleteFeed = exports.$deleteAnchor = void 0;
var _oldHttpClient = require("../../apiClient/oldHttpClient");
var _qs = _interopRequireDefault(require("qs"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var base = '/feed';
var baseAnchor = '/anchors';
var $deleteAnchor = _anchor => (0, _oldHttpClient.apiClient)({
  method: 'delete',
  url: "".concat(baseAnchor, "/").concat(_anchor)
});
exports.$deleteAnchor = $deleteAnchor;
var $deleteFeed = _feed => (0, _oldHttpClient.apiClient)({
  method: 'delete',
  url: "".concat(base, "/").concat(_feed)
});
exports.$deleteFeed = $deleteFeed;
var $getAnchors = () => (0, _oldHttpClient.apiClient)({
  method: 'get',
  url: "".concat(baseAnchor)
});
exports.$getAnchors = $getAnchors;
var $getFeed = _feed => (0, _oldHttpClient.apiClient)({
  method: 'get',
  url: "".concat(base, "/").concat(_feed)
});
exports.$getFeed = $getFeed;
var $getFeeds = () => (0, _oldHttpClient.apiClient)({
  method: 'get',
  url: "".concat(base)
});
exports.$getFeeds = $getFeeds;
var $patchFeed = (_feed, body) => (0, _oldHttpClient.apiClient)({
  method: 'patch',
  url: "".concat(base, "/").concat(_feed),
  body
});
exports.$patchFeed = $patchFeed;
var $patchMulticastFeed = (_feed, body) => (0, _oldHttpClient.apiClient)({
  method: 'patch',
  url: "".concat(base, "/").concat(_feed),
  body
});
exports.$patchMulticastFeed = $patchMulticastFeed;
var $postAcknowledgement = _feed => (0, _oldHttpClient.apiClient)({
  method: 'post',
  url: "".concat(base, "/").concat(_feed, "/acknowledgements")
});
exports.$postAcknowledgement = $postAcknowledgement;
var $postAnchor = _target => (0, _oldHttpClient.apiClient)({
  method: 'post',
  url: "".concat(baseAnchor),
  body: {
    _target
  }
});
exports.$postAnchor = $postAnchor;
var $postMulticastFeed = body => (0, _oldHttpClient.apiClient)({
  method: 'post',
  url: "".concat(base, "/multicast"),
  body
});
exports.$postMulticastFeed = $postMulticastFeed;
var $subscribeFeedTyping = (_feed, _client) => (0, _oldHttpClient.apiClient)({
  method: 'post',
  url: "".concat(base, "/").concat(_feed, "/subscribe"),
  body: {
    _client
  }
});
exports.$subscribeFeedTyping = $subscribeFeedTyping;
var $unsubscribeFeedTyping = (_feed, _client) => {
  var url = "".concat(base, "/").concat(_feed, "/subscribe?").concat(_qs.default.stringify({
    _client
  }));
  return (0, _oldHttpClient.apiClient)({
    method: 'delete',
    url
  });
};
exports.$unsubscribeFeedTyping = $unsubscribeFeedTyping;